import { LightningBoltOutlineIcon } from './LightningBoltOutlineIcon';

/**
 * author: Brooke Clifton
 * id 908D1C1F-8D3A-4316-8CF5-ABDF16747DA1
 * name lightning-bolt-outline
 * version: 5.1.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightning-bolt-outline.svg
 * tags
 * - Home Automation 
 * - Weather 
 */
export const StormOutlineIcon = LightningBoltOutlineIcon;
export default StormOutlineIcon